import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SafetyHint, SafetyHintType } from '@ecs-services/safety-hint/safety-hint.interface';
import { DefaultTooltipComponent, TooltipDirective } from '@os-components';
import { SewTag } from '@sew/ui-components-angular/standalone';
import { SafetyHintDialogService } from '../../../../components/safety-hint-dialog/safety-hint-dialog.service';

export enum SafetyHintTagType {
    ANTHRACITE = 'anthracite',
    YELLOW = 'yellow',
    RED = 'red',
}
@Component({
    selector: 'ecs-safety-hint-tag',
    templateUrl: './safety-hint-tag.component.html',
    styleUrls: ['./safety-hint-tag.component.scss'],
    imports: [TooltipDirective, SewTag, DefaultTooltipComponent],
})
export class SafetyHintTagComponent implements OnInit {
    @Input() public safetyHint?: SafetyHint;
    @Input() public dialogOpen?: boolean;

    @Output() public hintConfirmEvent = new EventEmitter<string>();

    public type!: SafetyHintTagType;
    public title!: string;
    public content!: string;

    public constructor(private safetyHintDialogService: SafetyHintDialogService) {}

    public ngOnInit(): void {
        this.type = this.getSafetyHintTagType(this.safetyHint);
        this.title = this.safetyHint?.title || '';
        this.content = this.safetyHint?.content || '';

        // initially open dialog
        if (this.dialogOpen) {
            this.openSafetyHintDialog();
        }
    }

    public openSafetyHintDialog() {
        this.safetyHintDialogService
            .showSafetyHintDialog(
                {
                    type: this.safetyHint?.type || '',
                    headline: this.title,
                    label: '',
                    status: this.title,
                    open: true,
                    size: 's',
                },
                {
                    markdownContent: this.content,
                }
            )
            .afterClosed$.subscribe(() => this.handleConfirmHint());
    }

    private handleConfirmHint() {
        this.hintConfirmEvent.emit();
    }

    private getSafetyHintTagType(safetyHint?: SafetyHint): SafetyHintTagType {
        switch (safetyHint?.type) {
            case SafetyHintType.WARNING:
                return SafetyHintTagType.YELLOW;
            case SafetyHintType.ERROR:
                return SafetyHintTagType.RED;
            default:
                return SafetyHintTagType.ANTHRACITE;
        }
    }
}
